import { render, staticRenderFns } from "./candidateSurvey.vue?vue&type=template&id=64c1ce9c&"
import script from "./candidateSurvey.vue?vue&type=script&lang=js&"
export * from "./candidateSurvey.vue?vue&type=script&lang=js&"
import style0 from "./candidateSurvey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports